import { useState, useCallback, useEffect } from "react";
import { Menu } from "@mui/material";
import NotificationMenu from "./CommonMenuDialog";
import { closeMenu, openMenu } from "../redux/reducer/menu/menuSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store"; 
import { ErrorWrapper } from "../providers/ErrorBoundary";

const CommonMenuDialog = () => {
    const [mounted, setMounted] = useState(false);
    const dispatch = useDispatch();
    const { isOpen, type, focus } = useSelector((state: RootState) => state.menu);
   
    

    const handleClose = useCallback(() => {
        dispatch(closeMenu());
        setMounted(false);
        dispatch(openMenu(null));
    }, [dispatch]);

    useEffect(() => {
        if (isOpen && !mounted) {
            setMounted(true);
        }
    }, [isOpen, mounted]);

    return (
        // <Menu anchorEl={focus} open={isOpen} onClose={handleClose} sx={{ position: 'absolute', right: 0, top: 0}}>
            <ErrorWrapper>
            {type === "notification" && <NotificationMenu />}
            </ErrorWrapper>
        // </Menu>
    );
};

export default CommonMenuDialog;
